/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

const { dark } = colors.light;
const { borderWidth, borderColor } = borders;

const darkActive = "#17c1e8";

export default {
  styleOverrides: {
    root: ({ theme }) => {
      const isDark = theme.palette.mode === "dark";
      return {
        color: isDark ? "rgba(255,255,255,0.18)" : borderColor,
        transition: "all 200ms linear",

        "&.Mui-active": {
          color: isDark ? darkActive : dark.main,
        },

        "&.Mui-completed": {
          color: isDark ? "rgba(23,193,232,0.55)" : dark.main,
        },
      };
    },

    alternativeLabel: {
      top: "14%",
      left: "-50%",
      right: "50%",
    },

    line: {
      borderWidth: `${borderWidth[2]} !important`,
      borderColor: "currentColor",
    },
  },
};
